import {
  Box,
  Table,
  TableContainer,
  TableRow,
  TableCell,
  ThemeProvider,
  TableBody,
  Typography,
  Divider,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import themeForm from "./ThemeForm";
import ReceiptHeader from "./ReceiptHeader";
import { formatCurrency2Digit } from "utils/helpers/format";
import { BorderBottom } from "@mui/icons-material";
import { makeStyles, styled } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  tbCell: {
    borderBottom: "1px solid #00BB9F",
  },
  borderLeft: {
    borderLeft: "1px solid #00BB9F",
  },
}));

const WarrantyForm = ({ data }) => {
  console.log({ data });
  const [productData, setProductData] = useState([]);

  const classes = useStyles();

  useEffect(() => {
    // Initialize any necessary state or effects here
    if (data && data.products) {
      setProductData(data.products);
    }
  }, [data]);

  const rowsPerPage = 9;

  return (
    <ThemeProvider theme={themeForm}>
      <Box
        p={3}
        mb={2}
        border={1}
        bgcolor={"background.paper"}
        borderColor="grey.300"
        borderRadius={2}
        height={"559px"}
        width={"794px"}
        position="relative"
      >
        <ReceiptHeader
          title="ใบรับประกันสินค้า"
          subtitle="Warranty Receipt"
          data={data}
        />

        <TableContainer
          sx={{
            mt: 2,
            border: "1px solid #00BB9F",
            borderRadius: "20px",
            width: "100%",
            height: "auto",
          }}
        >
          <Table>
            <TableBody>
              <TableRow>
                <TableCell className={classes.tbCell} colSpan={1}>
                  <Typography sx={{ color: "#00BB9F", fontWeight: "bold" }}>
                    วันที่
                  </Typography>
                </TableCell>
                <TableCell className={classes.tbCell} colSpan={3}>
                  <Typography>
                    {new Date().toLocaleDateString("th-TH", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })}
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tbCell} colSpan={1}>
                  <Typography
                    sx={{
                      color: "#00BB9F",
                      fontWeight: "bold",
                    }}
                  >
                    ชื่อสินค้า
                  </Typography>
                </TableCell>
                <TableCell className={classes.tbCell} colSpan={1}>
                  <Typography>
                    {data.product_name || "ไม่ระบุชื่อสินค้า"}
                  </Typography>
                </TableCell>
                <TableCell
                  className={`${classes.tbCell} ${classes.borderLeft}`}
                  colSpan={1}
                >
                  <Typography sx={{ color: "#00BB9F", fontWeight: "bold" }}>
                    รหัสสินค้า
                  </Typography>
                </TableCell>
                <TableCell className={classes.tbCell} colSpan={1}>
                  <Typography>
                    {data.product_code || "ไม่ระบุรหัสสินค้า"}
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tbCell} colSpan={1}>
                  <Typography sx={{ color: "#00BB9F", fontWeight: "bold" }}>
                    จำนวนสินค้า
                  </Typography>
                </TableCell>
                <TableCell className={classes.tbCell} colSpan={1}>
                  <Typography>{data.amount || "ไม่ระบุจำนวนสินค้า"}</Typography>
                </TableCell>
                <TableCell
                  className={`${classes.tbCell} ${classes.borderLeft}`}
                  colSpan={1}
                >
                  <Typography sx={{ color: "#00BB9F", fontWeight: "bold" }}>
                    ราคา/หน่วย
                  </Typography>
                </TableCell>
                <TableCell className={classes.tbCell} colSpan={1}>
                  <Typography>
                    {data.sell_price
                      ? `${formatCurrency2Digit(data.sell_price)} บาท`
                      : "ไม่ระบุราคา"}
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tbCell} colSpan={1}>
                  <Typography sx={{ color: "#00BB9F", fontWeight: "bold" }}>
                    การรับประกัน
                  </Typography>
                </TableCell>
                <TableCell className={classes.tbCell} colSpan={3}>
                  <Typography>
                    {data.resale_product_percentage
                      ? `${data.resale_product_percentage} %`
                      : "ไม่ระบุการรับประกัน"}
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={1}>
                  <Typography sx={{ color: "#00BB9F", fontWeight: "bold" }}>
                    มัดจำ
                  </Typography>
                </TableCell>
                <TableCell colSpan={1}>
                  <Typography>-</Typography>
                </TableCell>
                <TableCell className={`${classes.borderLeft}`} colSpan={1}>
                  <Typography sx={{ color: "#00BB9F", fontWeight: "bold" }}>
                    คงค้าง (บาท)
                  </Typography>
                </TableCell>
                <TableCell colSpan={1}>
                  <Typography>-</Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Box
          sx={{
            mt: 4,
            display: "flex",
            justifyContent: "flex-end",
            p: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "200px",
            }}
          >
            <Divider
              sx={{
                width: "100%",
                mb: 1,
                borderBottomWidth: 1,
              }}
            />
            <Typography sx={{ color: "#00BB9F", fontWeight: "bold" }}>
              ลงชื่อผู้ขาย
            </Typography>
            <Typography>
              {new Date().toLocaleDateString("th-TH", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            position: "absolute",
            bottom: 10,
            left: 10,
            right: 10,
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              color: "#00BB9F",
              fontSize: "10px",
            }}
          >
            หมายเหตุ: รับประกันสินค้าทุกชิ้น และรับคืนสินค้าในทุกกรณี
            สินค้าเสียหาย ชำรุดก่อนถึงมือลูกค้า
            หรือสินค้าไม่ตรงกับรายละเอียดที่ระบุไว้ (รับสินค้าคืนภายใน 3วัน)
          </Typography>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default WarrantyForm;
